import { css, cx } from '@emotion/css'
import { useIntl } from 'react-intl'
import { useSelector } from 'react-redux'

import { VyuTheme } from '../../../theme/types'
import { HomeBtnProps } from '../../../types/props'
import { RootState } from '../../../types/state'

const getStyle = (theme: VyuTheme) => {
  return css({
    color: theme.colors.v1?.primary,
    backgroundColor: theme.colors.v1?.secondary,
    border: `2px solid ${theme.colors.v1?.primary}`,
    fontFamily: theme.fonts?.v1?.primary?.family,
  })
}

const HomeBtn = ({ switchPage, brandEngagement }: HomeBtnProps) => {
  const vyuTheme = useSelector((state: RootState) => state.theme)

  const intl = useIntl()

  const style = getStyle(vyuTheme)

  return (
    <button
      className={cx(style, 'app-card__btn')}
      onClick={switchPage}
      style={brandEngagement?.button?.homeBtn?.style}
    >
      {brandEngagement?.theme?.messages?.['v1.Decide.HomeButton'] ??
        intl.formatMessage({ id: 'v1.Decide.HomeButton' })}
    </button>
  )
}

export default HomeBtn
